import React from "react";

export const Preloader = () => {
  return (
    <div>
      {/* start preloader */}
      <div className="preloader">
        <div className="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      {/* end preloader */}
    </div>
  );
};
